import type { IMenuSection } from '@fondationcss/ui';

const CATALOG_MODULE = 'Osmos.Catalog';
const HELP_MODULE = 'Osmos.Help';
// Menu ACL matches against fully-qualified permission names returned by /api/core/Me
// (SystemPermission.Name = "{module}.{permission}"), not the short names declared in the backend modules.
const PERMISSION_AUTHOR = `${CATALOG_MODULE}.Author`;
const PERMISSION_STUDENT = `${CATALOG_MODULE}.Student`;
const PERMISSION_LEARNING_ADMIN = `${CATALOG_MODULE}.LearningAdministrator`;
const PERMISSION_HELP_ADMIN = `${HELP_MODULE}.Administrateur`;

export const menus: IMenuSection[] = [
  {
    title: 'Étudiant',
    icon: 'graduation-cap',
    iconOnly: true,
    module: CATALOG_MODULE,
    permissions: [PERMISSION_STUDENT, PERMISSION_AUTHOR],
    groups: [
      { title: 'Tableau de bord', icon: 'gauge', to: '/student' },
      {
        title: 'Parcourir',
        icon: 'book-open',
        to: '/catalog',
        module: CATALOG_MODULE,
        permissions: [PERMISSION_STUDENT, PERMISSION_AUTHOR],
      },
    ],
  },
  {
    title: 'Administration',
    icon: 'shield-halved',
    iconOnly: true,
    permissions: [PERMISSION_AUTHOR, PERMISSION_HELP_ADMIN, PERMISSION_LEARNING_ADMIN],
    groups: [
      { title: 'Tableau de bord', icon: 'gauge', to: '/admin' },
      {
        title: 'Activité des apprenants',
        icon: 'chart-line',
        to: '/admin/activity',
        module: CATALOG_MODULE,
        permissions: [PERMISSION_AUTHOR],
      },
      {
        title: 'Projets',
        icon: 'folder-tree',
        to: '/authoring/projects',
        module: CATALOG_MODULE,
        permissions: [PERMISSION_AUTHOR],
      },
      {
        title: 'Gestion des accès',
        icon: 'user-lock',
        to: '/admin/access',
        module: CATALOG_MODULE,
        permissions: [PERMISSION_LEARNING_ADMIN],
      },
    ],
  },
];
